import React from 'react';
import { array } from 'prop-types';
import NavLink from './NavLink';
import './_nav.scss';

const Nav = ({ links }) => (
  <div className="nav-container">
    <div className="nav">
      <ul className="nav__pills nav">
        {links.map(({ path, icon, label }) => (
          <NavLink key={path} to={path} icon={icon} label={label} />
        ))}
      </ul>
    </div>
  </div>
);

Nav.propTypes = {
  links: array.isRequired
};

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.js